<template>
  <div>
    <div class="col-12 l-m-b-20">
      <div class="input-group search">
        <button type="button" class="btn input-group-btn" @click="clearSearch">
          <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
        </button>
        <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
      </div>
    </div>
    <template v-if="ratings.length">
      <div class="ratings-wrap">
        <div class="row pr-0 flex flex-column single-rating" v-for="(rating, index) in ratings" :key="index">
          <div class="flex justify-content-between pl-3 pt-2 pr-3">
            <span v-if="rating.author" class="rating-author">
              {{ rating.author.first_name }} {{ rating.author.last_name }}
            </span>
            <span v-else class="bg-danger text-white px-1 rounded">
              Deleted customer
            </span>
            <div class="flex flex-column align-items-end">
              <span class="ref-id">
                {{ rating.ref_id }}
              </span>
            </div>
          </div>
          <div class="flex pl-3 pr-3">
            <span class="rating-date-created pr-1">
              {{ rating.date }}
            </span>
          </div>
          <div class="flex">
            <div class="col-11 flex single-rating p-0">
              <div class="col-1 rating-grade-wrap p-0">
                <span class="rating-average">
                  {{ rating.rating }}
                </span>
                <span class="text-uppercase rating-subheading">
                  out of 5
                </span>
              </div>
              <div class="col-4 flex star-ratings-wrapper">
                <div class="flex flex-column">
                  <span class="rating-name">Service value</span>
                  <span class="rating-name">Communication</span>
                  <span class="rating-name">Punctuality</span>
                  <span class="rating-name">Mover commitment</span>
                  <span class="rating-name">Customer service</span>
                </div>
                <div class="flex flex-column">
                  <star-rating :rating="rating.value"
                               :star-size="11"
                               :show-rating="false"
                               :increment="0.1"
                               :read-only="true"
                               style="max-height: 16px"
                  />
                  <star-rating :rating="rating.communication"
                               :star-size="11"
                               :show-rating="false"
                               :increment="0.1"
                               :read-only="true"
                               style="max-height: 16px"
                  />
                  <star-rating :rating="rating.punctuality"
                               :star-size="11"
                               :show-rating="false"
                               :increment="0.1"
                               :read-only="true"
                               style="max-height: 16px"
                  />
                  <star-rating :rating="rating.commitment"
                               :star-size="11"
                               :show-rating="false"
                               :increment="0.1"
                               :read-only="true"
                               style="max-height: 16px"
                  />
                  <star-rating :rating="rating.customer_service"
                               :star-size="11"
                               :show-rating="false"
                               :increment="0.1"
                               :read-only="true"
                               style="max-height: 16px"
                  />
                </div>
              </div>
              <div class="col-7 row">
                <div class="rating-grade-wrap col-6">
                  <p class="customer-review text-break">
                    <read-more more-str="Show more" v-if="rating.body" :text="rating.body" less-str="Show less" :max-chars="300" />
                  </p>
                </div>
                <template v-if="!rating.reply && !rating.reply_at && $_can('companies.ratings.update-reply')">
                  <div class="col-6 flex justify-content-end align-items-start">
                    <button class="btn btn-primary" @click="ratingToReply = rating">
                      Reply to Customer Review
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div class="col-6">
                    <h5 class="text-secondary">Company response:</h5>
                    <p class="customer-review text-break">
                      <read-more more-str="Show more" v-if="rating.reply" :text="rating.reply" less-str="Show less" :max-chars="300" />
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="loading">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <span class="col-12 flex">
        No reviews
      </span>
    </template>
    <div class="col-12 flex">
      <div class="col-sm-6 mb-1 text-black-50"
           v-if="meta.total"
      >
        Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
      </div>
      <pagination class="col-sm-6 mb-1" :change-page="changePage" :meta="meta" />
    </div>
    <company-rating-reply-modal v-if="ratingToReply" :rating="ratingToReply" @close="closeReply" />
  </div>
</template>

<script>
import axios from 'axios';
import Pagination from '../../Pagination';
import CompanyRatingReplyModal from '../../jobs/modals/CompanyRatingReplyModal.vue';

export default {
  components: {
    CompanyRatingReplyModal,
    Pagination,
  },
  data: () => ({
    loading: false,
    page: 1,
    meta: [],
    q: '',
    ratings: [],
    ratingToReply: null,
  }),
  mounted() {
    this.getCompanyRatings(this.page, this.q);
  },
  methods: {
    closeReply() {
      this.getCompanyRatings(this.page, this.q);
      this.ratingToReply = false;
    },
    getCompanyRatings(page, q) {
      this.loading = true;
      axios
        .get(`/companies/${this.$route.params.id}/ratings?page=${page}&q=${q}`)
        .then(res => {
          this.ratings = res.data.data;
          this.meta = res.data.meta;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(pageNum) {
      this.page = pageNum;
      this.getCompanyRatings(this.page, this.q);
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.getRatingsSearch(this.page, this.q);
    },
    getRatingsSearch(page, q) {
      this.loading = true;
      axios
        .get(`companies/${this.$route.params.id}/ratings?page=${page}&q=${q}`)
        .then(res => {
          this.ratings = res.data.data;
          this.meta = res.data.meta;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
  },
};
</script>
<style lang="scss">
.ratings-wrap {
  height: 60vh;
  overflow-y: auto;
}
.single-rating {
  background-color: #f5f5f5;
  margin: 10px 20px 10px 20px;
  border-radius: 4px;
}
.rating-date-created {
  font-size: 10px;
  color: #999999;
  font-weight: 500;
}
.rating-grade-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rating-average {
  color: #4c5669;
  font-size: 40px;
  max-height: 53px;
  font-weight: 300;
}
.rating-subheading {
  font-size: 10px;
}
.rating-name {
  font-size: 10px;
  color: #8f8f8f;
  max-height: 16px;
}
.star-ratings-wrapper {
  justify-content: space-evenly;
  height: 90px;
}
.ref-id {
  font-size: 15px;
  font-weight: 700;
}
.customer-review {
  & p {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #6d7a86;
    margin-bottom: 12px;
    display: inline;
  }

  & a {
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ratings/CompanyRatingsList.vue